export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-480w.622fb0b3.png";